export async function subscribeToNewsletter(
  email: string,
  list_of_subscribed_offers: number[]
): Promise<{ success: boolean; data: any }> {
  try {
    const response = await fetch("/api/newsletterSubscriptions", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, list_of_subscribed_offers }),
    });

    const text = await response.text();

    if (!response.ok) {
      return { success: false, data: text };
    }
    return { success: true, data: text };
  } catch (error) {
    // Client failed to send fetch request
    let errorMessage = "Something went wrong.";

    if (error instanceof Error) {
      errorMessage = error.message;
    }

    return {
      success: false,
      data: { error: "Network error", details: errorMessage },
    };
  }
}
